export default "__VITE_ASSET__yyzMJ9z4__"